import * as React from 'react';

import { VisualizationZoneInfo } from 'components/visualization-zone-info';
import { useAppSelector } from 'store/store.hook';
import { selectVisualizationSliceInfo } from 'store/slices/visualization.slice';

import { BuildingViewEngine } from './building-view-engine';

interface BuildingViewProps {
  containerRef: any;
  containerWidth: number;
  containerHeight: number;
}

export const BuildingView: React.FC<BuildingViewProps> = (props) => {
  const { isHoveredPin } = useAppSelector(selectVisualizationSliceInfo);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const [ctx, setCtx] = React.useState<CanvasRenderingContext2D | null>(null);
  const [width, setWidth] = React.useState<number>(0);
  const [height, setHeight] = React.useState<number>(0);
  const { containerRef, containerWidth, containerHeight } = props;

  React.useEffect(() => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');

      setCtx(ctx);
    }
  }, [canvasRef]);

  React.useEffect(() => {
    setWidth(containerWidth || containerRef?.current?.offsetWidth || 0);
    setHeight(containerHeight || containerRef?.current?.offsetHeight || 0);
  }, [containerRef, containerWidth, containerHeight]);

  return (
    <>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{
          cursor: isHoveredPin ? 'pointer' : 'move',
        }}
      />

      <BuildingViewEngine ctx={ctx} width={width} height={height} />

      <VisualizationZoneInfo width={width} height={height} />
    </>
  );
};
